class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prev = this.querySelector('[data-carousel-prev]');
    this.next = this.querySelector('[data-carousel-next]');

    if (!this.track) return;

    this.prev?.addEventListener('click', () => this.scrollByCard(-1));
    this.next?.addEventListener('click', () => this.scrollByCard(1));
    this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.updateControls());
    this.resizeObserver.observe(this.track);
    this.updateControls();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  getCardStep() {
    const card = this.track.querySelector('[data-carousel-card]');
    if (!card) return this.track.clientWidth;
    const styles = getComputedStyle(this.track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  scrollByCard(direction) {
    this.track.scrollBy({ left: direction * this.getCardStep(), behavior: 'smooth' });
  }

  updateControls() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const maxScroll = Math.max(0, scrollWidth - clientWidth);
    const overflowing = maxScroll > 4;

    this.classList.toggle('is-overflowing', overflowing);

    const media = this.track.querySelector('.product-carousel__media');
    if (media) {
      const carouselRect = this.getBoundingClientRect();
      const mediaRect = media.getBoundingClientRect();
      const top = mediaRect.top - carouselRect.top + mediaRect.height / 2;
      this.style.setProperty('--carousel-nav-offset', `${top}px`);
    }

    if (this.prev) {
      this.prev.disabled = !overflowing || scrollLeft <= 4;
    }

    if (this.next) {
      this.next.disabled = !overflowing || scrollLeft >= maxScroll - 4;
    }
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel);
}
